// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VDRA","select":"styles_select__3zS0P"};